import Vue from 'vue';
import Vuex from 'vuex';
import {
  application,
  category,
  location,
  payment,
  order,
  user,
} from 'quasar-pilot-core';
import layout from './layout';

Vue.use(Vuex);
export default async () => new Vuex.Store({
  modules: {
    application,
    category,
    location,
    payment,
    order,
    user,
    layout,
  },
});
